import { RadicationCompleteComponent } from './pages/radication-complete/radication-complete.component';
import { StringFormatPipe } from './shared/pipe/string.format.pipe';
import { SolicitationDataComponent } from './pages/solicitation-data/solicitation-data.component';
import { HttpBackend, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NavigationService } from './shared/services/navigation/navigation-service.service';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { 
  SegmentTypes, 
  VoxelConfigModule, 
  VoxelButtonModule, 
  VoxelAlertModule, 
  VoxelMaskModule, 
  VoxelModalModule, 
  VoxelDialogModule, 
  VoxelTabsModule, 
  VoxelAutocompleteModule,
  VoxelFormFieldModule, 
  VoxelInputModule, 
  VoxelIconModule, 
  VoxelSelectModule, 
  VoxelCheckboxModule, 
  VoxelFormSelectionModule,
  VoxelLoadingCircleModule, 
  VoxelAccordionModule, 
  VoxelListModule, 
  VoxelTooltipModule 
  } from '@voxel/components';
import { SolicitationDetailComponent } from '../app/pages/solicitation-detail/solicitation-detail.component';
import { SolicitationStartComponent } from './pages/solicitation-start/solicitation-start.component';
import { ItemNamePipe } from './shared/pipe/item-name.pipe';
import { FormSolicitationBasicDataComponent } from './pages/form-solicitation-basic-data/form-solicitation-basic-data.component';
import { FormSolicitationContactsDataComponent } from './pages/form-solicitation-contacts-data/form-solicitation-contacts-data.component';
import { FormSolicitationAdditionalDataComponent } from './pages/form-solicitation-additional-data/form-solicitation-additional-data.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DuplicateCallInterceptor } from './shared/interceptors/duplicate-call.interceptor';
import { MessageErrorFormFieldDirective } from './shared/directives/message-error-form-field.directive';
import { CommonModule } from '@angular/common';
import { UnicodePipe } from './shared/pipe/unicode.pipe';
import { VclSnackBarModule, VclStepperModule, VclTableModule } from '@voxel/community';
import { SolicitationSearchComponent } from './pages/solicitation-search/solicitation-search.component';
import { FormSolicitationSearchComponent } from './pages/form-solicitation-search/form-solicitation-search.component';
import { VclAutocompleteModule } from '@voxel/community';
import { SolicitationModalTypificationComponent } from './pages/solicitation-modal-typification/solicitation-modal-typification.component';

import { RequirementsStartComponent } from './pages/requirements-start/requirements-start.component';
import { FormRequirementBasicDataComponent } from './pages/form-requirement-basic-data/form-requirement-basic-data.component';
import { HttpFetchBackend } from './shared/helpers/http-fetch-backend';
import { FileSizePipe } from './shared/pipe/file-size.pipe';
import { SharedComponentsModule } from './shared/components/shared-components.module';
import { FiducialBankHomeComponent } from './pages/fiducial-bank-home/fiducial-bank-home.component';
import { BankStartComponent } from './pages/bank-start/bank-start.component';
import { TermsConditionsModalComponent } from './pages/terms-conditions-modal/terms-conditions-modal.component';
import { StepsInformationModalComponent } from './pages/steps-information-modal/steps-information-modal.component';
import { UploadFilesComponent } from './pages/upload-files/upload-files.component';
import { CleanAutocompleteComponent } from './pages/clean-autocomplete/clean-autocomplete.component';

import { DaliModule } from '@dali/tagger-ng12';
import { RecaptchaErrorComponent } from './pages/recaptcha-error/recaptcha-error.component';

@NgModule({
  declarations: [
    AppComponent,
    SolicitationDataComponent,
    SolicitationDetailComponent,
    SolicitationStartComponent,
    ItemNamePipe,
    FormSolicitationBasicDataComponent,
    FormSolicitationContactsDataComponent,
    FormSolicitationAdditionalDataComponent,
    RadicationCompleteComponent,
    MessageErrorFormFieldDirective,
    UnicodePipe,
    SolicitationSearchComponent,
    FormSolicitationSearchComponent,
    SolicitationModalTypificationComponent,
    RequirementsStartComponent,
    FormRequirementBasicDataComponent,
    FileSizePipe,
    FiducialBankHomeComponent,
    BankStartComponent,
    TermsConditionsModalComponent,
    StepsInformationModalComponent,
    UploadFilesComponent,
    StringFormatPipe,
    CleanAutocompleteComponent,
    RecaptchaErrorComponent
  ],
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    BrowserModule,
    VoxelFormFieldModule,
    VoxelAccordionModule,
    VoxelInputModule,
    VoxelListModule,
    VclTableModule,
    //VoxelTableModule,
    VoxelSelectModule,
    VoxelIconModule,
    VoxelTooltipModule,
    VoxelButtonModule,
    VoxelModalModule,
    VoxelCheckboxModule,
    VoxelFormSelectionModule,
    VoxelAutocompleteModule,
    //VclModalModule,
    VclStepperModule,
    VclSnackBarModule,
    VoxelAlertModule,
    //VclDialogModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    HttpClientModule,
    VoxelConfigModule.forRoot({
      segment: SegmentTypes.Varejo,
    }),
    VoxelMaskModule,
    VoxelDialogModule,
    VoxelTabsModule,
    VoxelLoadingCircleModule,
    VclAutocompleteModule,
    SharedComponentsModule,
    DaliModule
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  providers: [
    NavigationService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: DuplicateCallInterceptor,
      multi: true
    },
    { provide: HttpBackend, useClass : HttpFetchBackend }
    /*{
      provide: HTTP_INTERCEPTORS,
      useClass: HttpMockApiInterceptor,
      multi: true
    },*/
  ],
  bootstrap: [AppComponent]
})
/**
 * Pruebas
 */
export class AppModule { }
